import React from "react";
import { FormPasswordComponent, FormPhoneComponent } from "../../../site/impl/components";
import { LoginContainerFactory } from "../screens";

export class LoginContainerFactoryImpl implements LoginContainerFactory {
    constructor(private currentStep: number, private setStep: React.Dispatch<React.SetStateAction<number>>) { }
    create(): React.ReactNode {
        if (this.currentStep === 1) {
            return <FormPhoneComponent step={this.currentStep} setStep={this.setStep} />
        }
        return <FormPasswordComponent step={this.currentStep} setStep={this.setStep} />
    }
}